const permissionGroups = [
  {
    value: [1],
    description: "Admin",
    info:
      "User can manage all grants, accounts, organizations and users; and see all statistics and grant applications.",
    fundsGranted: true
  },
  {
    value: [2, 3, 4],
    description: "Grant Manager",
    info:
      "User can manage all grants. This includes grant finding and publishing.",
    fundsGranted: true
  },
  {
    value: [12],
    description: "Blog Writer",
    info:
      "User can add blog posts.",
    fundsGranted: true
  },
  {
    value: [13],
    description: "Blog Approver",
    info:
      "User can edit and approve blog posts.",
    fundsGranted: true
  },
  {
    value: [12, 13],
    description: "Blog Manager",
    info:
      "User can add, edit, and delete all blog posts.",
    fundsGranted: true
  },
  {
    value: [5],
    description: "Account Rep",
    info:
      "User can manage all accounts. This includes managing organizations and users.",
    fundsGranted: true
  },
  {
    value: [6],
    description: "Template Manager",
    info: "User can manage all templates.",
    fundsGranted: true
  },
  {
    value: [5, 8, 9, 10],
    description: "Account Manager",
    info:
      "User can manage this account. This includes managing all organizations and users.",
    fundsGranted: false
  },
  {
    value: [7, 8, 9, 10],
    description: "Organization Manager",
    info:
      "User can manage this organization and any sub-organization. This includes managing users assigned to these organizations.",
    fundsGranted: false
  },
  {
    value: [],
    description: "User",
    info:
      "User has no management permissions. This still allows full functionality of the website/app for the grant process.",
    fundsGranted: false
  }
];

export { permissionGroups };
